import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class GenreService {
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient, private auth: AuthService) { }

  getgenre() {
    let headers = new HttpHeaders();
    headers = headers.set("content-type", "application/json");
    headers = headers.set("Authorization", "Bearer " + environment.bearerToken);
    return this.http.get(`${this.baseUrl}v1/courses/pub/recorded/`, { headers });
  }

  getgenreByName(genre: string | null, loginToken: string) {
    let headers = new HttpHeaders();
    headers = headers.set("content-type", "application/json");
    if (loginToken != "not")
      headers = headers.set("Authorization", "Bearer " + this.auth.getToken());
    else
      headers = headers.set(
        "Authorization",
        "Bearer " + environment.bearerToken
      );
    return this.http.get(`${this.baseUrl}v1/courses/p/recorded/${genre}`, {
      headers,
      withCredentials: true
    });
  }
}
